// extracted by mini-css-extract-plugin
module.exports = {"yellow_star":"styles_yellow_star__ldPdE","grey_star":"styles_grey_star__PLwHD"};